module.exports = __webpack_public_path__ + "img/button_delete_icon.8de2f1c5.svg";